import { fetchGet, fetchPost, rootApi } from '../helpers/api';

const portfolioFaultApi = `${rootApi}/stations/portfolioFault`;
const portfolioApi = `${rootApi}/stations/portfolio`;

export const portfolioFaultTotalize = payload => fetchPost(`${portfolioFaultApi}/totalizePortfolioFault`, payload);
export const getPortfolioFaultDetails = payload => fetchPost(`${portfolioFaultApi}/getPortfolioFaultDetails`, payload);
export const getPortfolioFault = payload => fetchPost(`${portfolioFaultApi}/getPortfolioFault`, payload);
export const getPortfolioFaultLog = payload => fetchPost(`${portfolioFaultApi}/getPortfolioFaultLog`, payload);
export const getPortfolioFaultLevel = () => fetchGet(`${portfolioApi}/getPortfolioLevel`);
